<template>
  <div>
    <Modal v-model="showStatus" width="1200" @on-ok="$emit('close')" @on-cancel="$emit('close')">
      <div slot="header">登录日志（{{ currentData.name }}）</div>
      <Table
        border
        :columns="table.columns"
        :data="table.data"
        style="margin-top: 12px"
        :max-height="760"
        ref="tableRef"
      ></Table>
      <Page style="margin-top:10px;" :total="page.total" show-total :current="page.currentPage"
        :page-size-opts="page.pageSizes" :page-size="page.pagesize" show-sizer
        @on-page-size-change="pageSizeChange" @on-change="pageChange"></Page>
    </Modal>
    <Modal v-model="showDetail" width="1200">
      <div slot="header">登录详情</div>
      <Card dis-hover>
        <p slot="title">登录详情JSON</p>
        <json-viewer sort copyable :value="loginDetail"></json-viewer>
      </Card>
    </Modal>
  </div>
</template>

<script>
import JsonViewer from "vue-json-viewer";
import transToReq from '@/api/trans'

export default {
  name: "seePrantModal",
  props: [
    'visible',
    "currentData"
  ],
  components: {
    JsonViewer
  },
  data() {
    return {
      showStatus: false,
      table: {
        data: [],
        columns: [
          {key: 'time', title: '登录时间', align: "center", resizable: true},
          {key: 'login_ip', title: '登录IP', align: "center", resizable: true},
          {key: 'login_info', title: '登录IP所在地', align: "center", resizable: true},
          {key: 'user_type', title: '登录方式', align: "center", resizable: true, render: (h, params) => {
            const { row } = params
            const txtMap = {
              '1': '游客',
              '2': '手机',
              '3': '微信',
              '4': '第三方',
              '5': '账号密码',
            }
            return h('span', txtMap[row.user_type])
          }},
          {key: 'detail', title: '详情', align: "center", resizable: true, render: (h, params) => {
            return h(
              'Button',
              {
                props: { type: "primary" },
                style: { marginRight: "5px" },
                on: {
                  click: () => {
                    this.showDetail = true
                    this.loginDetail = JSON.parse(params.row.login_detail)
                  },
                },
              },
              "登录详情"
						)
          }},
        ]
      },
      page: {
				total: 0,
				totalSum: 0,
				pagesize: 15,
				pageSizes: [15, 30, 45, 60],
				currentPage: 1,
			},
      showDetail: false,
      loginDetail: {}
    };
  },
  methods: {
    getListData() {
      const { user_id, app_id } = this.currentData
      const params = {
        page: this.page.currentPage,
				limit: this.page.pagesize,
        user_id,
        app_id
      }
      transToReq('GetUserLoginList', params).then(res => {
        if (res._param.list) {
          this.table.data = res._param.list
          this.page.total = res._param.total
        }
      })
    },
    pageChange(page) {
			this.page.currentPage = page
			this.getListData()
		},
		pageSizeChange(size) {
			this.page.pagesize = size
			this.getListData()
		},
  },
  watch: {
    // 监听导出数据弹窗是否显示
    visible (val) {
      if (val) {
        this.showStatus = true
        this.getListData()
      }
    }
  }
};
</script>
